import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import CSOBBuyerGuide from "./Guide";

import CardGuide from "@components/common/CardGuide/CardGuide";

interface GuideContainer {}

const GuideContainer: FC<GuideContainer> = () => {
  const { t } = useTranslation();
  const steps: CardGuide["steps"] = [
    {
      title: `${t("common.step")} 1`,
      description: t("sellers.importList"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.importListOfSuppliers"),
          t("csob.supplier.hub.point.useDownloadedCsvTemplate"),
          t("csob.supplier.hub.point.modifyTableToUpdateDetails"),
          t("csob.supplier.hub.point.listActsAsValidation"),
        ],
      },
    },
    {
      title: `${t("common.step")} 2`,
      description: t("csob.supplier.hub.shareSupplierRegistrationPage"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.clickCopyLinkButton"),
          t("csob.supplier.hub.point.shareLinkWithSuppliers"),
          t("csob.supplier.hub.point.onlyMatchingVatAndEmail"),
        ],
      },
    },
    {
      title: `${t("common.step")} 3`,
      description: t("csob.supplier.hub.suppliersDataEntryProcess"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.afterSuccessfulRegistration"),
          t("csob.supplier.hub.point.checkStatusOfDataGathering"),
        ],
      },
    },
    {
      title: `${t("common.step")} 4`,
      description: t("csob.supplier.hub.analyzeResultsInDashboard"),
      detail: {
        title: t("csob.supplier.guidenceTitle"),
        points: [
          t("csob.supplier.hub.point.calculationResultsOnDashboard"),
          t("csob.supplier.hub.point.selectPeriodAndSupplier"),
          t("csob.supplier.hub.point.applyRelevantFilters"),
        ],
      },
    },
  ];

  return <CSOBBuyerGuide steps={steps} />;
};

export default GuideContainer;
